import { useAtom } from 'jotai';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { fairUsageModalOpenAtom } from '@/atoms/fairUsageModal';
import { useHasBeenOpened } from '@/components/Modals/hooks/useHasBeenOpened';

/**
 * Query-string flag for previewing this modal without forcing an API error
 * code 4. Useful for designers / QA / VRT. Intentionally obscure to avoid
 * accidental triggers. Lives on the wrapper rather than the modal body so
 * the body can stay code-split until something actually opens it.
 */
const FORCE_OPEN_QUERY_PARAM = '__force_fair_usage_checkpoint';
const FairUsageCheckpointModalContent = dynamic(() => import('./FairUsageCheckpointModal'), {
  ssr: false
});

/**
 * Mounted globally in `_app`, so only this thin wrapper is in the main
 * bundle (DEV-6485) — the dialog/drawer body is fetched the first time the
 * checkpoint fires.
 */
const FairUsageCheckpointModal = () => {
  const [open, setOpen] = useAtom(fairUsageModalOpenAtom);
  const {
    query
  } = useRouter();
  const hasBeenOpened = useHasBeenOpened(open);
  useEffect(() => {
    if (query[FORCE_OPEN_QUERY_PARAM] !== undefined) {
      setOpen(true);
    }
  }, [query, setOpen]);
  if (!hasBeenOpened) {
    return null;
  }
  return <FairUsageCheckpointModalContent data-sentry-element="FairUsageCheckpointModalContent" data-sentry-component="FairUsageCheckpointModal" data-sentry-source-file="index.tsx" />;
};
export { FairUsageCheckpointModal };